<template>
  <div>
    <jala-pond-select-ajax
        v-if="!initialValue.pond_id"
        v-show="!value"
        :key="`${_uid}-jala-cycles-ponds`"
        name="pond_id"
        v-model.number="pond_id"
        :disabled="disabled"
        :initial-value="initialValue"
    ></jala-pond-select-ajax>
    <multiselect-ajax
        v-show="pond_id || value"
        :class="{ 'mt-3': !(value || initialValue.pond_id) }"
        :key="`${_uid}-jala-cycles-${pond_id}`"
        name="cycle_id"
        :placeholder="$t('Select {something}', { something: $t('jala_cycles.singular') })"
        :value="value"
        @input="(v) => onInput(v)"
        @update:selected="$emit('update:selected', $event)"
        :custom-label="customLabel || customLabelDefault"
        :required="required"
        :disabled="disabled"
        :url="`/jala/cycles`"
        :params="{ pond_id__in: pond_id, with: 'pond.farm', ...params }"
    >
      <template v-slot:beforeList>
        <b-button variant="link" v-b-modal="`${_uid}-jala-cycle-create-modal`">+
          {{ $t('Add new {something}', {something: $t('jala_cycles.singular')}) }}
        </b-button>
        <jala-cycle-create-modal
            :key="`${_uid}-jala-cycle-create-modal-${value}`"
            :id="`${_uid}-jala-cycle-create-modal`"
            size="lg"
            @created="onInput($event.id)"
            :initial-value="{ pond_id }"
        ></jala-cycle-create-modal>
      </template>
      <template v-slot:option="{ option }">
        <slot name="option" v-bind="{ option }"></slot>
      </template>
    </multiselect-ajax>
  </div>
</template>

<script>
import MultiselectAjax from "./vue-multiselect-ajax";
import JalaPondSelectAjax from "./jala-pond-select-ajax";
import JalaCycleCreateModal from '../modals/jala-cycle-create';

export default {
  name: "jala-cycle-select-ajax",
  components: {
    MultiselectAjax,
    JalaPondSelectAjax,
    JalaCycleCreateModal,
  },
  props: {
    value: {
      type: Number,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      pond_id: this.initialValue.pond_id || null
    }
  },
  computed: {
    customLabelDefault() {
      if (this.value)
        return (v) => `${v.pond.farm.name} - ${v.pond.name} - ${this.$moment(v.started_at).format('DD MMMM YYYY')}`;
      else return (v) => this.$moment(v.started_at).format('DD MMMM YYYY')
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
